import { render, staticRenderFns } from "./BenefitPackageLayout.vue?vue&type=template&id=ea84c76a&scoped=true&"
import script from "./BenefitPackageLayout.vue?vue&type=script&lang=js&"
export * from "./BenefitPackageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea84c76a",
  null
  
)

export default component.exports